module.exports = __webpack_public_path__ + "img/ad2f43b.png";